import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { TrendingUp } from "lucide-react";

/**
 * Shows the top 10 most viewed SEO pages from seo_page_views.
 * Falls back to hardcoded popular pages if no analytics data.
 * Renders raw <a>-style Link tags for crawlability.
 */

const fallbackPages = [
  { href: "/films", label: "Films en streaming VF" },
  { href: "/series", label: "Séries en streaming VF" },
  { href: "/football", label: "Football en direct" },
  { href: "/ufc", label: "UFC & MMA en direct" },
  { href: "/nos-offres", label: "Nos offres IPTV" },
  { href: "/abonnement-iptv", label: "Abonnement IPTV" },
  { href: "/iptv-france", label: "IPTV France" },
  { href: "/iptv-pas-cher", label: "IPTV pas cher" },
  { href: "/abonnement-iptv-12-mois", label: "Abonnement IPTV 12 mois" },
  { href: "/tutoriels", label: "Tutoriels d'installation" },
];

function buildHref(pageType: string, slug: string): string {
  const prefix: Record<string, string> = {
    movie: "/films",
    series: "/series",
    football: "/football",
    ufc: "/ufc",
  };
  return `${prefix[pageType] || ""}/${slug}`;
}

const PopularPagesBlock = () => {
  const { data: topPages } = useQuery({
    queryKey: ["popular-pages-block"],
    queryFn: async () => {
      const { data } = await supabase
        .from("seo_page_views")
        .select("page_slug, page_title, page_type, views_count")
        .order("views_count", { ascending: false })
        .limit(10);
      return data || [];
    },
    staleTime: 10 * 60 * 1000,
  });

  const pages = topPages && topPages.length >= 5
    ? topPages.map(p => ({
        href: buildHref(p.page_type, p.page_slug),
        label: p.page_title || p.page_slug.replace(/-/g, " "),
      }))
    : fallbackPages;

  return (
    <section className="py-8 px-4">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-lg font-bold text-foreground mb-4 flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-primary" />
          Pages populaires sur RoiDuStreaming
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
          {pages.map((p) => (
            <Link
              key={p.href}
              to={p.href}
              className="px-3 py-2 rounded-lg text-sm bg-card border border-border/50 text-muted-foreground hover:text-primary hover:border-primary/40 transition-colors text-center truncate"
            >
              {p.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularPagesBlock;
